export enum AllStateInsuranceEventType {
  OFFER_ELEMENT_LOAD = 'onOfferElementLoad',
  VIEW_CHANGE = 'onViewChange',
  ON_BLUR = 'onBlur',
  ON_CHECKBOX_SELECTION = 'onCheckboxSelection',
}

export enum AllStateInsuranceViewId {
  MISSING_CUSTOMER_INFO = 'missingCustomerInfo',
  MISSING_RENTAL_ADDRESS_INFO = 'missingRentalAddressInfo',
  MISSING_CURRENT_ADDRESS_INFO = 'missingCurrentAddressInfo',
  QUICK_QUOTE_LOADER = 'quickQuoteLoader',
  CHOOSE_YOUR_PACKAGE = 'chooseYourPackage',
  ADDITONAL_DETAILS_PERSONS = 'additionalDetailsPersons',
  PAYMENT_SELECTION = 'paymentSelection',
  CHECKOUT = 'checkout',
  YOURE_COVERED = 'youreCovered',
}

export enum MatrixProtectLogStepType {
  OFFER_ELEMENT_LOAD = 'offer_element_load',
  CUSTOMER_INFO = 'customer_info',
  RENTAL_ADDRESS_INFO = 'rental_address_info',
  CURRENT_ADDRESS_INFO = 'current_address_info',
  QUICK_QUOTE_LOADER = 'quick_quote_loader',
  CHOOSE_YOUR_PACKAGE = 'choose_your_package',
  ADDITIONAL_DETAILS = 'additional_details',
  PAYMENT_SELECTION = 'payment_selection',
  CHECKOUT = 'checkout',
  TERMS_AND_CONDITIONS_ACCEPTED = 'terms_and_conditions_accepted',
  CLOSED = 'closed',
  SKIPPED = 'skipped',
}

export enum MatrixProtectLogType {
  STANDALONE = 'standalone',
  IN_APP_CREATION = 'in_app_creation',
  POST_SUBMISSION = 'post_submission',
}
